<template>
  <div class="item-out-container">
    <ds-page-header :title="$t('itemOutManage.page.title')" :subtitle="$t('itemOutManage.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="_openAddItemOutModal">
          {{ $t('itemOutManage.list.apply') }}
        </el-button>
        <el-button size="small" icon="el-icon-download" @click="_exportExcel">
          {{ $t('common.export') }}
        </el-button>
      </template>
    </ds-page-header>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="6" :md="5" :lg="4">
        <div class="ds-panel ds-panel--padded">
          <div class="ds-panel__header">
            <span class="ds-panel__title">{{ $t('itemOutManage.stateFilter') }}</span>
          </div>
          <ul class="ds-state-list">
            <li v-for="(item, index) in itemOutManageInfo.states" :key="index" @click="swatchState(item)"
              :class="{ 'is-active': itemOutManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :xs="24" :sm="18" :md="19" :lg="20">
        <ds-search-panel>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="itemOutManageInfo.conditions.applyOrderId" clearable class="w-full"
                :placeholder="$t('itemOutManage.search.applyOrderId')" @keyup.enter.native="_queryInspectionPlanMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="itemOutManageInfo.conditions.applyUserName" clearable class="w-full"
                :placeholder="$t('itemOutManage.search.applyUserName')" @keyup.enter.native="_queryInspectionPlanMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="itemOutManageInfo.conditions.resName" clearable class="w-full"
                :placeholder="$t('itemOutManage.search.resName')" @keyup.enter.native="_queryInspectionPlanMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-date-picker v-model="itemOutManageInfo.conditions.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('itemOutManage.search.startTime')" style="width: 100%" />
            </el-col>
            <el-col v-show="moreCondition" :xs="24" :sm="12" :md="8" :lg="6">
              <el-date-picker v-model="itemOutManageInfo.conditions.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('itemOutManage.search.endTime')" style="width: 100%" />
            </el-col>
          </el-row>
          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="_queryInspectionPlanMethod">{{ $t('common.search') }}</el-button>
            <el-button icon="el-icon-refresh-left" @click="_resetInspectionPlanMethod">{{ $t('common.reset') }}</el-button>
            <el-button type="text" @click="moreCondition = !moreCondition">{{ moreCondition ? $t('itemOutManage.hide') : $t('itemOutManage.more') }}</el-button>
          </template>
        </ds-search-panel>

        <div class="ds-panel">
          <ds-toolbar :total="pagination.total" :density="density" :show-column-setting="false" :show-refresh="true"
            @update:density="density = $event" @refresh="_listItemOuts">
            <template #left>
              <span class="ds-panel__title">{{ $t('itemOutManage.list.title') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="itemOutManageInfo.itemOuts" :loading="loading" :error="hasError"
            :error-message="errorMessage" :density="density" border :empty-description="$t('itemOutManage.page.empty')" @retry="_listItemOuts">
            <el-table-column prop="applyOrderId" :label="$t('itemOutManage.table.applyOrderId')" align="center" width="170">
              <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyOrderId || '-' }}</span></template>
            </el-table-column>
            <el-table-column prop="resourceNames" :label="$t('itemOutManage.table.resourceNames')" align="center" min-width="180" show-overflow-tooltip />
            <el-table-column prop="userName" :label="$t('itemOutManage.table.userName')" align="center" min-width="100" />
            <el-table-column prop="createUserName" :label="$t('itemOutManage.table.createUserName')" align="center" min-width="100" />
            <el-table-column prop="createTime" :label="$t('itemOutManage.table.createTime')" align="center" width="170">
              <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
            </el-table-column>
            <el-table-column prop="stateName" :label="$t('itemOutManage.table.stateName')" align="center" width="110">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="scope.row.state == '1000' ? 'warning' : scope.row.state == '2000' ? 'success' : 'muted'" :label="scope.row.stateName || '-'" />
              </template>
            </el-table-column>
            <el-table-column :label="$t('itemOutManage.table.warehousingWay')" align="center" width="120">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="scope.row.warehousingWay === 10000 ? 'muted' : 'info'"
                  :label="scope.row.warehousingWay === 10000 ? $t('itemOutManage.table.directOut') : $t('itemOutManage.table.auditOut')" />
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" align="center" width="240" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openDetailItemOutModel(scope.row)">{{ $t('common.view') }}</el-button>
                <el-button v-if="scope.row.warehousingWay !== 10000" size="mini" @click="_openRunWorkflowImage(scope.row)">{{ $t('itemOutManage.table.flowChart') }}</el-button>
                <el-button v-if="scope.row.state === '1000' && itemOutManageInfo.currentUserId === scope.row.createUserId"
                  size="mini" type="danger" @click="_openDeleteItemOutModel(scope.row)">{{ $t('itemOutManage.table.cancelApply') }}</el-button>
              </template>
            </el-table-column>
          </ds-data-table>

          <ds-pagination-bar :page="pagination.currentPage" :size="pagination.pageSize" :total="pagination.total"
            :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </el-col>
    </el-row>

    <delete-item-out ref="deleteItemOut" @success="handleSuccess" />
    <view-image ref="viewImage" />
  </div>
</template>

<script>
import { listPurchaseApplys, exportData, listRunWorkflowImage } from '@/api/resource/itemOutManageApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import DeleteItemOut from '@/components/resource/deleteItemOut'
import ViewImage from '@/components/system/viewImage'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ItemOutManageList',
  components: { DeleteItemOut, ViewImage, DsPageHeader, DsSearchPanel, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false, hasError: false, errorMessage: '', density: 'default', moreCondition: false,
      itemOutManageInfo: {
        itemOuts: [],
        states: [{ statusCd: '', name: this.$t('common.all') }],
        currentUserId: '',
        conditions: { applyOrderId: '', state: '', applyUserName: '', resOrderType: '20000', resName: '', startTime: '', endTime: '', communityId: '' }
      },
      pagination: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created() {
    this.itemOutManageInfo.currentUserId = getUserId()
    this.itemOutManageInfo.conditions.communityId = getCommunityId()
    this.initData()
  },
  methods: {
    async initData() { await this.getDictData(); this._listItemOuts() },
    async getDictData() {
      try {
        const data = await getDict('purchase_apply', 'state')
        this.itemOutManageInfo.states = [{ statusCd: '', name: this.$t('common.all') }, ...data]
      } catch (error) { console.error('获取字典数据失败:', error) }
    },
    async _listItemOuts() {
      this.loading = true; this.hasError = false
      try {
        const params = { page: this.pagination.currentPage, row: this.pagination.pageSize, ...this.itemOutManageInfo.conditions }
        const { data, total } = await listPurchaseApplys(params)
        this.itemOutManageInfo.itemOuts = data
        this.pagination.total = total
      } catch (error) { console.error('获取数据失败:', error); this.hasError = true; this.errorMessage = this.$t('common.loadError') } finally { this.loading = false }
    },
    _openAddItemOutModal() { this.$router.push({ path: '/views/resource/addItemOut', query: { resOrderType: this.itemOutManageInfo.conditions.resOrderType } }) },
    _openDetailItemOutModel(itemOut) { this.$router.push({ path: '/views/resource/purchaseApplyDetail', query: { applyOrderId: itemOut.applyOrderId, resOrderType: this.itemOutManageInfo.conditions.resOrderType } }) },
    _openDeleteItemOutModel(itemOut) { this.$refs.deleteItemOut.open(itemOut) },
    _queryInspectionPlanMethod() { this.pagination.currentPage = 1; this._listItemOuts() },
    _resetInspectionPlanMethod() {
      this.itemOutManageInfo.conditions = { applyOrderId: '', state: '', applyUserName: '', resOrderType: '20000', resName: '', startTime: '', endTime: '', communityId: getCommunityId() }
      this.pagination.currentPage = 1; this._listItemOuts()
    },
    async _openRunWorkflowImage(itemOut) {
      try {
        const params = { businessKey: itemOut.applyOrderId, communityId: getCommunityId() }
        const { data } = await listRunWorkflowImage(params)
        this.$refs.viewImage.open({ url: 'data:image/png;base64,' + data })
      } catch (error) { console.error('获取流程图失败:', error) }
    },
    async _exportExcel() {
      try {
        const params = { ...this.itemOutManageInfo.conditions, pagePath: 'itemOutManage' }
        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=downloadCenter')
      } catch (error) { console.error('导出失败:', error) }
    },
    swatchState(item) { this.itemOutManageInfo.conditions.state = item.statusCd; this._listItemOuts() },
    handleSuccess() { this._listItemOuts() },
    handleSizeChange(val) { this.pagination.pageSize = val; this.pagination.currentPage = 1; this._listItemOuts() },
    handleCurrentChange(val) { this.pagination.currentPage = val; this._listItemOuts() }
  }
}
</script>

<style lang="scss" scoped>
.item-out-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header { display: flex; align-items: center; justify-content: space-between; padding-bottom: var(--ds-spacing-md); margin-bottom: var(--ds-spacing-md); border-bottom: 1px solid var(--ds-gray-200); }
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); }
}
.ds-state-list { list-style: none; margin: 0; padding: 0;
  li { padding: var(--ds-spacing-sm) var(--ds-spacing-md); font-size: var(--ds-font-size-sm); color: var(--ds-gray-600); border-radius: var(--ds-radius-sm); cursor: pointer; text-align: center; margin-bottom: var(--ds-spacing-xs);
    &:hover { background: var(--ds-gray-100); color: var(--ds-primary); }
    &.is-active { background: var(--ds-primary-sub); color: var(--ds-primary); font-weight: 600; } }
}
.w-full { width: 100%; }
</style>
